<div *ngIf="{ adConfigMap: adConfigMap$ | async } as subs" class="px-3 px-sm-45">
  <div class="lazy-ad ad-skin d-none d-xl-block">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="subs.adConfigMap | mapGet: 'skin'"
    ></flo-lazy>
  </div>
  <main
    class="result-page font-family-regular text-700"
    *ngIf="result$ | async as results"
  >
    <div class="mb-3 d-none d-lg-block lazy-ad">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="subs.adConfigMap | mapGet: 'flex-large'"
      ></flo-lazy>
    </div>
    <div class="lazy-ad mb-3 d-none d-md-block d-lg-none">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="subs.adConfigMap | mapGet: 'flex-small'"
      ></flo-lazy>
    </div>
    <div class="container" data-test="result-page-container">
      <div class="row" *ngIf="results?.headerInfo">
        <section class="col-md-12 selected-result">
          <flo-section-header
            [event]="results?.headerInfo"
            data-test="result-header"
          ></flo-section-header>
        </section>
      </div>
      <section class="px-sm-2 px-lg-4 py-4">
        <flo-result-widget
          [results]="results.resultWidget"
          (sortChange)="sortFormChange($event)"
        ></flo-result-widget>
      </section>
    </div>
    <div class="stick-to-footer">
      <div class="lazy-ad adhesion-ad d-sm-none">
        <flo-lazy
          [componentConstructor]="AdComponent"
          [initialProps]="subs.adConfigMap | mapGet: 'adhesion'"
        ></flo-lazy>
      </div>
    </div>
  </main>
</div>
